module.exports = __webpack_public_path__ + "static/media/chart-scatter.649574a5.svg";